import { Button } from "@/components/ui/button";
import { ComponentProps } from "react";

type ButtonProps = ComponentProps<typeof Button> & {
  title: string;
};

const ButtonDemo = ({ title, className, ...props }: ButtonProps) => {
  return (
    <Button
      {...props}
      className={`bg-primary border-primary lg:hover:bg-background lg:hover:text-primary min-h-11 rounded-none border-2 px-6 py-2.5 text-sm font-bold text-white shadow-xs transition-[background-color,border-color,color,box-shadow] duration-300 ${className ?? ""}`}
    >
      {title}
    </Button>
  );
};

export default ButtonDemo;
